import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    text: String,
    inputText: String
  }

  remove() {
    const checkbox = document.querySelector(`input[data-input-name="${this.inputTextValue}"]`);

    if (checkbox) {
      checkbox.dispatchEvent(new CustomEvent("tag-closed", {
        bubbles: true,
        detail: {
          inputText: this.inputTextValue
        }
      }));

      requestAnimationFrame(() => this.manageFocus());
    }
  }

  manageFocus() {
    const tagsContainer = document.getElementById('filter-tags');
    const remainingTags = tagsContainer ? tagsContainer.querySelectorAll('button, a, [role="button"]') : [];
    if (remainingTags.length > 0) {
      remainingTags[0].focus();
    } else {
      const heading = document.getElementById('room-list-label');
      heading.setAttribute('tabindex', '-1');
      heading.focus();
    }
  }
} 
